var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 40,
    viewBox: "0 0 19 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61428 19.9333C6.61428 11.9381 11.2443 4.74243 18.52 1.6776C18.7846 1.54435 18.9168 1.14459 18.7846 0.878079C18.6523 0.611572 18.52 0.611572 18.2554 0.611572H0V39.3883H18.2554C18.52 39.3883 18.7846 39.1218 18.7846 38.8553C18.7846 38.5888 18.6523 38.4556 18.52 38.3223C11.2443 35.1242 6.61428 27.9285 6.61428 19.9333Z",
    fill: "#0284C7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.9c58c0262940d1b9d052a10c4e6cfb30.svg";
export { ForwardRef as ReactComponent };